import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View,StyleSheet } from 'react-native';
import { TextInput, TextArea } from '@dbk/ui-forms';
import { createContainer } from '@dbk-legacy/muster/react';
import { H3, Small } from '@dbk/ui-text';
import Dropdown from '@dbk/ui-dropdowns';
import format from 'date-fns/format';
import styles from './payment-details.styles';
import DateSelectionBar from '../../../../components/common/date-selection-bar';
import CalendarModal from '../../../../components/common/calendar-modal';
import SimpleDate from '../../../../components/common/date';
import PymtCharge from '../payment-charge-component/payment-charge';
import PymtReason from '../payment-reason-component/payment-reason';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import moment from 'moment';
import 'moment/min/locales';
import Text from '@dbk/ui-text';
import {EBANKINGWEBUK, RM_REGION_UK } from '../../../../constants';
import envConfig from '../../../../../db-env-build'

class PaymentDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
    selectedDay: moment(this.props.payments.startDate),
    remarks:this.props.payments.remarks ? this.props.payments.remarks : ''
  }
}
  getJsonObject = costList => costList && costList.length ?
    costList.map(e => ({
      label : `${e.costType}: ${e.ebLabelDesc}`,
      value : `${e.costType}: ${e.ebLabelDesc}`

    })) : null


  getPaymentReasonList = paymentreasonList => paymentreasonList && paymentreasonList.length ?
    paymentreasonList.map(e=> ({
      label: `${e.ebLabelDesc}`,
      value: `${e.payReasonKey}`
    })) : null

  componentDidUpdate(){
      if (this.props.reports.closeDatePicker === true && this.datepickerRef && this.datepickerRef.datepicker && this.datepickerRef.datepicker.state && this.datepickerRef.datepicker.state.isOpen ) {
        this.onCancel();
      }
      if(this.props.payments.remarks){
        this.setState({remarks:this.props.payments.remarks ? this.props.payments.remarks : ''})
      }
    }

  onCancel = () => {
      this.datepickerRef.datepicker.closeCalendar();
      this.props.setDatePickerClose(false);
  }

  getDefaultItemForDropDown = () => {

    const {
      payments: {
        selectedCost,
        costList,
      },
    } = this.props;

    const cost = selectedCost || costList[0];
    return `${cost.costType}: ${cost.ebLabelDesc}`;

  }
  handleTextChange = text => {    
    if(typeof text === 'object'){      
      const { target: { value } } = text;
      this.props.payments.setRemarks(value.trimStart());
      //this.setState({remarks: value.trimStart()});
    } else {
      this.props.payments.setRemarks(text.trimStart());
      // this.setState({remarks: text.trimStart()});
    }   
  }
  handlePaymentReason = value => {
    if(value === '') return;
   
    this.props.payments.setPaymentReason(value);
    this.handleTextChange('')
  }
  handleCostsSelect = value => {
    if(value === '') return;
    const {
      payments: {
        costList,
      },
    } = this.props;

    const cost = costList.filter(obj => value.includes(obj.costType))[0];
    this.props.payments.setSelectedCost(cost)
  }

  onDayChange = (date) => {
    this.props.payments.setStartDate(moment(date).format('YYYY-MM-DD'));
  }

  customFooter = () => {
    const { i18n: { messages } } = this.props;
    return <div inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" }} >
        <div style={{ padding: "2px", display: "inline-grid", float: 'left' }}>
            <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
        </div>
    </div>
}

  render() {
    const {
      payments: {
        remarks,
        selectedCost,
        costList,
        startDate,
        calendar,
        paymentType,
        paymentReasonList,
        paymentReason,
      },
      i18n: { messages },
      auth: { langCode },
      handleRemarksScroll,
      isSwiftCodePresent
    } = this.props;
    const languageCode = langCode ? langCode.toLowerCase() : 'en';
    const isUKRegion = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK);
    const showCost = !(paymentType.includes('internal') || paymentType.includes('sepa') || isUKRegion )    

    /*Start*/
    // WMCE-42144 DWO LUX - International Payment to PSD2-country w/o BEN charging option
    let filteredArray =[];
    if(isSwiftCodePresent && paymentType.includes('international') ){
      filteredArray = costList.filter(function(value, index, arr){ 
        return value.costType !== "BEN" ;
      });
    }
    /*End*/
   // const isUKRegion = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK);
    return (
      <View >
        <div>
          <div className="payment-filter-input">
          <Text secondary className='paymentHeading' tabIndex={0}>{messages['app.payments.execDate']}</Text>
          <View style={{flex:1, flexDirection:'row'}} >
            <div className='dateFullWidth input-container margin-top-8 margin-bottom-20' id="datepicker_paymentExecutionDate_paymentDetails_test" aria-label={messages['app.payment.selectDate']}>
                <DatePicker
                  tabIndex={-1}
                  type='portrait'
                  tetherProps={{attachment : "top center", targetAttachment : "right center"}}
                  ref={(ref) => this.datepickerRef = ref}
                  onChange={this.onDayChange}
                  showOutsideMonthDays={false}
                  value={moment(startDate).toDate()}
                  startDate={moment().add(-2, 'years').toDate()}
                  selectionStart={moment(startDate)}
                  inputDateFormat={'dd MMM yyyy'}
                  disableWeekendDays
                  disablePastDays
                  renderFooter={() => this.customFooter()}
                  // readOnly
                  locale={this.props.auth.langCode}
                  weekStartsOn={1} // Monday is the first day of the week.
                  />
            </div>
          </View>

            {
              showCost &&
              <View style={{flex:1, flexDirection:'row' }}>
                <Text secondary className='paymentHeading margin-bottom-8' tabIndex={0}>{messages['app.payments.costs']}</Text>
                <PymtCharge/>
              </View>
            }
            {
              showCost && selectedCost &&
              <div aria-label={messages['app.payment.costsDropdown']} className='margin-bottom-20'>
              <Dropdown
              tabIndex={0}
              title={messages['app.payment.costsDropdown']}
              testID="dropdown_domesticPayment_cost_paymentDetail_test"
              size='large'
              selected={`${selectedCost.costType}: ${selectedCost.ebLabelDesc}`}
              onChange={this.handleCostsSelect}
              options={ filteredArray.length > 0 ? this.getJsonObject(filteredArray):this.getJsonObject(costList)}
              className="customDropDownHtWdth paymentCostDropDown"
              defaultLabel     //WMCE-41653
              />
              </div>
            }

            {isUKRegion &&
              <View>
                <View style={{flex:1, flexDirection:'row', alignItems:'center'}}>
                  <Text secondary tabIndex={0} className='paymentHeading margin-bottom-8'>{messages['app.payment.reason']}</Text>
                  <span style={StyleSheet.flatten(styles.asteriskStyle)}>*</span>
                  <PymtReason />
                </View>
              <View accessibilityLabel={paymentReason || messages['app.payment.reason.dropdown.default.label']}>
                <Dropdown
                  testID="dropdown_UKPayment_reason_test"
                  size='large'
                  selected={paymentReason && paymentReason.toString()}
                  title={messages['app.payment.reason.dropdown.default.label']}
                  onChange={(e) => this.handlePaymentReason(e)}
                  options={this.getPaymentReasonList(paymentReasonList)}
                  className="customDropDownHtWdth margin-bottom-20"
                  defaultLabel={messages['app.payment.reason.dropdown.default.label']}
                />
              </View>
              </View>

              
            }

            <Text className='paymentHeading' tabIndex={0} secondary>{messages['app.payment.additional.beneficiary.information'] } {isUKRegion && <span style={StyleSheet.flatten(styles.asteriskStyle)}>*</span>}</Text> 

            <div>
              <TextArea
                  testID="textarea_domesticPayment_remark_paymentDetail_test"
                  placeholder = { isUKRegion  ? messages['app.payment.additional.information.placeholder.UK'] : messages['app.payments.remark.placeholder'] }
                  className="remarksMultiLineTextInput margin-top-8"
                  value={remarks }
                  spellCheck="false"
                  onChange={this.handleTextChange}
                  onFocus={handleRemarksScroll}
                  style={{height: 60, flex:1,width:'100%'}}
                  maxLength={isUKRegion ? 110 : 137 }
                />     
            </div>
          </div>
        </div>
       </View>
    );
  }
}

PaymentDetails.propTypes = {
  payments: PropTypes.shape({
    selectedCost  : PropTypes.object.isRequired,
    costList      : PropTypes.array.isRequired,
    setRemarks    : PropTypes.func.isRequired,
    setSelectedCost  : PropTypes.func.isRequired,
  }).isRequired,
  changePage: PropTypes.func.isRequired,
  i18n : PropTypes.object.isRequired,
}

export default createContainer({
  $queries: {
     i18n: {
      messages: true,
    },
    auth: {
      langCode: true,
    },
    payments:{
      calendar: {
        open: {
          $call: 'open'
        },
        ...CalendarModal.getFragment( 'calendarModal' ),
      },
      startDate: true,
      setPaymentReason: { $set: 'paymentReason'},
      setStartDate: { $set: 'startDate' },
      remarks: true,
      setRemarks : { $set : 'remarks' },
      selectedCost: true,
      setSelectedCost: { $set : 'selectedCost' },
      costList: true,
      paymentReason: true,
      paymentReasonList: true,
      paymentType: true,
      sepaCountryBicIsoCodeList: true,
      setcostList: { $set: 'costList' }
    },
    reports:{
      closeDatePicker:true
    },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
    changePage: { $call: 'ui.history.push' },
  },
})(PaymentDetails);
